exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-field {\n  position: relative;\n  margin-top: 0.6rem;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/register/register.component.css
// module id = ../../../../../src/app/register/register.component.css
// module chunks = main